module.exports = __webpack_public_path__ + "img/t4-5.77521c51.jpg";